import React from 'react';
import * as Styles from './Banner.styles';
import Icon from './media/AiAnimation.webp';
import { Button } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';

const Banner = ({
  bannerText, bannerButtonLabel, toggleIframe, guideRef,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  return (
    <Styles.Wrapper>
      <Styles.TextWrapper>
        <Styles.AnimationWrapper>
          <Styles.AnimationIcon src={Icon} />
        </Styles.AnimationWrapper>
        <Styles.Description>{bannerText}</Styles.Description>
      </Styles.TextWrapper>
      <Styles.ButtonWrapper ref={guideRef}>
        <Button
          label={bannerButtonLabel}
          variant="secondary"
          onClick={toggleIframe}
          size="medium2"
          width={isMobile ? 'full' : 'fit-content'}
        />
      </Styles.ButtonWrapper>
    </Styles.Wrapper>
  );
};

export default Banner;
